export enum EOperationType {
  /** 表态 */
  reaction = 'reaction',
  /** 回复 */
  reply = 'reply',
  /** 置顶 */
  top = 'top',
  /** 多选 */
  multiSelect = 'multi-select',
  /** 分享 */
  share = 'share',
  /** 撤回 */
  cancel = 'cancel',
  /** 举报 */
  report = 'report',
  /** 复制 */
  copy = 'copy',
  /** 添加 */
  add = 'add',
  /** 位置 */
  position = 'position',
}

export type TOperationSetting = {
  /** 类型 */
  type: EOperationType;
  /** 文字显示 */
  text: string;
  /** 图标 */
  icon: string;
  /** 是否有分割线(默认：无) */
  hasCutOffLine?: boolean;
  /** 展示顺序 */
  order?: number;
  /** hover状态时，是否有右箭头(默认：无) */
  hasHoverRightArrow?: boolean;
};


export type TOperateSettingMap = Record<Partial<EOperationType>, TOperationSetting>;
